/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import {extendTheme} from '@salesforce/retail-react-app/app/components/shared/ui'
import {overrides as baseOverrides} from './base'
import dynamiteOverrides from './brands/dynamite'

// Brand-specific theme override mappings
const brandOverrides = {
    dynamite: dynamiteOverrides
}

// Pre-build the base theme and all brand themes at module load time.
// extendTheme performs deep merging — doing it once avoids runtime cost on navigation.
const baseTheme = extendTheme(baseOverrides)
const themes = {base: baseTheme}
Object.entries(brandOverrides).forEach(([brandId, overrides]) => {
    themes[brandId] = extendTheme(baseOverrides, overrides)
})

/**
 * Returns the pre-built Chakra theme for the given brand.
 * Falls back to the base theme if brand is not found.
 *
 * @param {string} brandId - e.g. 'dynamite'
 * @returns {object} Chakra UI theme object
 */
export const getThemeForBrand = (brandId) => {
    return themes[brandId] || baseTheme
}

// Re-export the overrides for backward compatibility
export {overrides} from './base'

// Default export: base theme (used when no brand override applies)
export default baseTheme
